export default __webpack_public_path__ + "static/1.6-Headings-DO-e29337f238c6124e010e53b0c6425b79.png";